import { Pill, type PillVariant } from "@/components/podkit/status/Pill";
import type { PlainWorkflowExecution } from "@/queries/automation-queries";
import { hasFailedActions, workflowExecutionPhaseLabel } from "@/utils/automations";
import { WorkflowExecutionPhase } from "gitpod-next-api/gitpod/v1/workflow_pb";
import type { FC } from "react";

export const WorkflowExecutionStatusPill: FC<{ execution: PlainWorkflowExecution }> = ({ execution }) => {
    const variant = variantFromPhase(execution);
    return (
        <Pill variant={variant} size={"md"} className="w-fit">
            {workflowExecutionPhaseLabel(execution)}
        </Pill>
    );
};

function variantFromPhase(execution: PlainWorkflowExecution): PillVariant {
    switch (execution.status?.phase) {
        case WorkflowExecutionPhase.PENDING:
        case WorkflowExecutionPhase.UNSPECIFIED:
        case WorkflowExecutionPhase.RUNNING:
        case WorkflowExecutionPhase.STOPPING:
        case WorkflowExecutionPhase.STOPPED:
        case WorkflowExecutionPhase.DELETING:
        case WorkflowExecutionPhase.DELETED:
            return "info";
        case WorkflowExecutionPhase.COMPLETED:
            return hasFailedActions(execution) ? "danger" : "success";
    }
}
